<template>
  <div class="currency-unit-selector">
    <el-select
      :value="value"
      @input="handleInput"
      :multiple="multiple"
      :placeholder="placeholder"
      filterable
      clearable
      :disabled="disabled"
      style="width: 100%">
      
      <el-option
        v-for="unit in currencyUnits"
        :key="unit.unitId"
        :label="getUnitLabel(unit)"
        :value="unit.unitId">
        <span class="option-content">
          <span class="unit-info">
            <span class="unit-name">{{ unit.unitAka || unit.unitName }}</span>
            <span class="unit-id">(ID: {{ unit.unitId }})</span>
          </span>
          <span class="unit-type">{{ getCurrencyTypeName(unit.currencyUnit?.type) }}</span>
        </span>
      </el-option>
      
      <div v-if="currencyUnits.length === 0" slot="empty" class="empty-state">
        <i class="el-icon-info"></i>
        <p>暂无可选的货币组件</p>
        <p class="tip">请先添加货币组件</p>
      </div>
    </el-select>
    
    <!-- 选中的货币组件预览 -->
    <div v-if="selectedUnits.length > 0" class="selected-preview">
      <div class="preview-header">
        <span>已选择的货币组件：</span>
        <el-button v-if="multiple" size="mini" type="text" @click="clearAll">清空全部</el-button>
      </div>
      <div class="selected-items">
        <el-tag
          v-for="unit in selectedUnits"
          :key="unit.unitId"
          closable
          @close="removeUnit(unit.unitId)"
          style="margin-right: 8px; margin-bottom: 4px;">
          {{ unit.unitAka || unit.unitName }} (ID: {{ unit.unitId }})
        </el-tag>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrencyTypeName } from '@/utils/unitTypeConstants'

export default {
  name: 'CurrencyUnitSelector',
  props: {
    value: {
      type: [Array, Number],
      default: () => []
    },
    allUnits: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择货币组件'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 筛选出货币组件
    currencyUnits() {
      return this.allUnits.filter(unit => unit.unitType === 1)
    },
    
    // 获取选中的组件
    selectedUnits() {
      if (this.multiple) {
        const selectedIds = Array.isArray(this.value) ? this.value : []
        return this.currencyUnits.filter(unit => selectedIds.includes(unit.unitId))
      } else {
        const selectedId = this.value
        return selectedId ? this.currencyUnits.filter(unit => unit.unitId === selectedId) : []
      }
    }
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value)
    },
    
    getUnitLabel(unit) {
      return `${unit.unitAka || unit.unitName} (ID: ${unit.unitId})`
    },
    
    getCurrencyTypeName(type) {
      return getCurrencyTypeName(type)
    },
    
    removeUnit(unitId) {
      if (this.multiple) {
        const newValue = this.value.filter(id => id !== unitId)
        this.$emit('input', newValue)
      } else {
        this.$emit('input', null)
      }
    },
    
    clearAll() {
      if (this.multiple) {
        this.$emit('input', [])
      } else {
        this.$emit('input', null)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.currency-unit-selector {
  .option-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    
    .unit-info {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 8px;
      
      .unit-name {
        font-weight: 500;
      }
      
      .unit-id {
        color: #909399;
        font-size: 12px;
      }
    }
    
    .unit-type {
      color: #409eff;
      font-size: 12px;
      background-color: #ecf5ff;
      padding: 2px 6px;
      border-radius: 3px;
    }
  }
  
  .empty-state {
    text-align: center;
    padding: 20px;
    color: #909399;
    
    i {
      font-size: 24px;
      margin-bottom: 8px;
      display: block;
    }
    
    p {
      margin: 4px 0;
      
      &.tip {
        font-size: 12px;
        color: #c0c4cc;
      }
    }
  }
  
  .selected-preview {
    margin-top: 12px;
    padding: 12px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #e9ecef;
    
    .preview-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      font-size: 13px;
      color: #606266;
      font-weight: 500;
    }
    
    .selected-items {
      .el-tag {
        margin-right: 8px;
        margin-bottom: 4px;
      }
    }
  }
}

::v-deep .el-select-dropdown__item {
  height: auto;
  padding: 8px 20px;
  line-height: normal;
}
</style> 